/** Storage helpers that never throw (private mode, quota, disabled storage). */

function safe<T>(fn: () => T, fallback: T): T {
  try {
    return fn();
  } catch {
    return fallback;
  }
}

export const local = {
  get<T>(key: string, fallback: T): T {
    return safe(() => {
      const raw = window.localStorage.getItem(key);
      return raw === null ? fallback : (JSON.parse(raw) as T);
    }, fallback);
  },
  set(key: string, value: unknown) {
    safe(() => window.localStorage.setItem(key, JSON.stringify(value)), undefined);
  },
  remove(key: string) {
    safe(() => window.localStorage.removeItem(key), undefined);
  },
};

export const session = {
  get<T>(key: string, fallback: T): T {
    return safe(() => {
      const raw = window.sessionStorage.getItem(key);
      return raw === null ? fallback : (JSON.parse(raw) as T);
    }, fallback);
  },
  set(key: string, value: unknown) {
    safe(() => window.sessionStorage.setItem(key, JSON.stringify(value)), undefined);
  },
  remove(key: string) {
    safe(() => window.sessionStorage.removeItem(key), undefined);
  },
};
